import React, { Component } from "react";
import { WVUSForm } from "wvus-forms";
import { SponsorsEmailChildForm } from "../Form/SponsorsEmailChildForm";

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  getInitialState() {
    // Override Initial State Here
    const overrideState = {};

    const initialState = {
      data: {
        sponsorFirstName: "",
        sponsorLastName: "",
        sponsorEmail: "",
        sponsorAccountNumber: "",
        childName: "",
        childID: "",
        message: ""
      },
      alert: {
        status: null,
        message: ""
      }
    };

    // Return Initial State
    return Object.assign({}, initialState, overrideState);
  }

  render() {
    const SponsorsEmailChildFormDisplay = WVUSForm(SponsorsEmailChildForm);

    return (
      <div className="app-container">
        <div className="in-app-hero-image">
          <picture>
            <source
              media="(min-width: 768px)"
              srcSet="https://wvusstatic.com/emc/unauth/email-my-child-form.jpg"
              alt="Email Child"
            />
            <img src="https://wvusstatic.com/emc/unauth/email-my-child-form-mobile-hero.jpg" alt="Email Child"></img>
          </picture>
        </div>
        <div className="in-app-content">
          <h1 className="form-title">Email Child</h1>
          <div className="form-intro">
            <p>
              Every sponsored child loves getting email, especially when it is from their sponsor! Now sending an email
              is just a click away. Fill out form below to send a special message to your sponsored child.
            </p>
            <p>
              Your e-mail will arrive in the National Office of your sponsored child&apos;s country where our staff will
              print it out translate it and deliver it to your sponsored child. Then your child will respond with a
              letter via standard mail. Thank you for your faithfulness as a sponsor and your continued support.
            </p>
          </div>
          <div className="form-wrapper">
            <SponsorsEmailChildFormDisplay setAlert={this.setAlert} />
          </div>
        </div>
      </div>
    );
  }
}
